import { useTranslation } from '../../i18n/i18n';
import { Main } from '../Main/Main';
import { Routing } from '../Routes';

export const NotFoundPage = (): JSX.Element => {
	const t = useTranslation().notFoundPage;
	return (
		<Main>
			<h1>{t.couldNotFindPage}</h1>
			<p>{t.thePageYoureLookingFor}</p>
		</Main>
	);
};

export const notFoundRouting: Routing = {
	path(_urls) {
		return '/404';
	},
	component: NotFoundPage,
	requiresAuth: false,
};
